import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './layout/layout';
import Home from './pages/home/home';
import About from './pages/about/about';
import WorkParent from './pages/work/workParent';
import WorkChild from './pages/work/workChild';


function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/work" element={<WorkParent />} />
          <Route path="/work/:projectId" element={<WorkChild />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
